import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/core/components/ui/dropdown-menu";
import { VIEWER_OVERLAY_CLASSNAME } from "./utils";

// Cursor position and zero-based Glide index of the right-clicked header.
export interface ColumnHeaderMenuTarget {
  x: number;
  y: number;
  columnIndex: number;
}

interface ColumnHeaderMenuProps {
  target: ColumnHeaderMenuTarget | null;
  frozenColumn: number | null;
  isSaving: boolean;
  onClose: () => void;
  onFrozenColumnChange: (frozenColumn: number | null) => void;
}

export const ColumnHeaderMenu = ({
  target,
  frozenColumn,
  isSaving,
  onClose,
  onFrozenColumnChange,
}: ColumnHeaderMenuProps) => (
  <DropdownMenu
    open={target !== null}
    onOpenChange={(open) => {
      if (!open) onClose();
    }}
    modal={false}
  >
    <DropdownMenuTrigger asChild>
      <span
        aria-hidden
        className="pointer-events-none fixed h-0 w-0"
        style={{ left: target?.x ?? 0, top: target?.y ?? 0 }}
      />
    </DropdownMenuTrigger>
    <DropdownMenuContent
      align="start"
      className={VIEWER_OVERLAY_CLASSNAME}
      // Keep the menu open when Glide refocuses its canvas after Control+click.
      onFocusOutside={(event) => event.preventDefault()}
    >
      <DropdownMenuItem
        disabled={!target || isSaving}
        onSelect={() => {
          if (target) onFrozenColumnChange(target.columnIndex + 1);
        }}
      >
        Freeze through this column
      </DropdownMenuItem>
      {frozenColumn !== null && (
        <>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            disabled={isSaving}
            onSelect={() => onFrozenColumnChange(null)}
          >
            Unfreeze columns
          </DropdownMenuItem>
        </>
      )}
    </DropdownMenuContent>
  </DropdownMenu>
);
